/* eslint-disable max-len */

const FileMoveOutline: React.FC = () => (
  <svg width="17" height="19" viewBox="0 0 17 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.66671 0.887939H2.00004C1.08337 0.887939 0.333374 1.63794 0.333374 2.55461V15.8879C0.333374 16.2296 0.433374 16.5546 0.616707 16.8213C0.675041 16.9129 0.750041 16.9963 0.825041 17.0629C1.12504 17.3713 1.54171 17.5546 2.00004 17.5546H8.27504C7.83337 17.0713 7.50837 16.5129 7.29171 15.8879H2.00004V2.55461H7.83337V6.72127H12V9.22127C12.5834 9.22127 13.1417 9.32127 13.6667 9.50461V5.88794L8.66671 0.887939ZM12 18.3879L16.1667 14.6379L13.6667 12.3879L12 10.8879V13.3879H8.66671V15.8879H12V18.3879Z"/>
  </svg>
);
export default FileMoveOutline;
